<template>
  <zj-layout-container>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable" style="height:100%;">
      <el-tabs class="user-tabs" v-model="editableTabsValue" height="100%">
        <el-tab-pane
          :key="item.name"
          v-for="(item) in editableTabs"
          :label="item.value"
          :name="item.code"
        >
          <UserOrgControl
            v-bind="$attrs"
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :ResourceTypeId="item.code"
            :ref="item.code"></UserOrgControl>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </zj-layout-container>
</template>
<script>
//import MyApis from "../../../apis";
import UserOrgControl from "./UserOrgControl";
import { getDictionary } from "@/api/src/emergency_common";
export default {
  name: "ZjUserTabControl",
  controller: "UI",
  action: "UserTabControl",
  components: {
    UserOrgControl
  },
  props: {
    editable: { type: Boolean, default: false },
  },
  data() {
    return {
      ruleForm: {},
      editableTabs: [],
      editableTabsValue: "",
      orgOptions: [],
      OgrVal: ""
    };
  },
  created: function() {
    this.showLoading('加载中...');
    getDictionary('organization_type')
      .then(d => {
        if (d.data.records && d.data.records.length > 0) {
          this.editableTabs = d.data.records;
          this.editableTabsValue = d.data.records[0].code;
        }
        this.hideLoading();
      })
      .catch(e => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetOrgUserIds() {
      var userids = [];
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.code][0];
        var usids = chil.GetUserIds();
        for (var j = 0; j < usids.length; j++) {
          userids.push(usids[j]);
        }
      }
      return userids;
    },
    GetCheckedUserItems() {
      var reuslt = [];
      for (var i = 0; i < this.editableTabs.length; i++) {
        var item = this.editableTabs[i];
        var chil = this.$refs[item.code][0];
        var checkItems = chil.GetCheckedUserItems();
        console.log(checkItems,i)
        reuslt = reuslt.concat(checkItems);
      }
      return reuslt;
    }
  }
};
</script>
